import MojitoCore from 'mojito/core';
import Button from 'presentation/components/button/index.js';
import Image from 'presentation/components/image/index.js';
import Text from 'presentation/components/text/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';
import { omit } from 'mojito/utils';

const UIViewUtils = MojitoCore.Presentation.UIViewUtils;
const DEFAULT = 'default';
const ACTIVE = 'active';
const DISABLED = 'disabled';

const ImageButton = props => {
    const {
        label,
        active,
        disabled,
        mojitoTools: { config, style },
        alt,
    } = props;
    const propsWithoutLabel = omit(props, ['label', 'alt']);
    const mode = getMode(active, disabled);

    const elementsConfig = style[mode];
    return (
        <Button {...UIViewUtils.omitComponentOwnProps(propsWithoutLabel)} config={config.button}>
            <FlexPane config={config.innerContainer}>
                <Image alt={alt} class={'ta-imageButtonIcon'} config={elementsConfig.icon} />
                {label && (
                    <Text class={'ta-imageButtonLabel'} config={elementsConfig.label}>
                        {label}
                    </Text>
                )}
            </FlexPane>
        </Button>
    );
};

const getMode = (active, disabled) => {
    if (active) {
        return ACTIVE;
    } else if (disabled) {
        return DISABLED;
    }
    return DEFAULT;
};

ImageButton.getStyle = (config, mode, merge) => {
    const { buttonIcon, buttonIconActive, buttonLabel, buttonLabelActive, buttonIconDisabled } =
        config;
    return {
        [DEFAULT]: { icon: buttonIcon, label: buttonLabel },
        [ACTIVE]: {
            icon: merge(buttonIcon, buttonIconActive),
            label: merge(buttonLabel, buttonLabelActive),
        },
        [DISABLED]: {
            icon: merge(buttonIcon, buttonIconDisabled),
        },
    };
};

export default ImageButton;
